<div class="law-update-container">
  <!-- 搜尋區域 - 現在位於頂部 -->
  <div class="search-bar">
    <div class="search-section">
      <div class="search-controls">

           <!-- 快速選單 - 移到這裡與其他搜尋條件同一行 -->
           <div class="search-control">
            <label for="quickMenu">快速選單：</label>
            <div class="multi-select-container">
              <!-- 使用與其他下拉選單相似的樣式 -->
              <select id="quickMenu" class="quick-menu-select" (change)="applyQuickFilter($event)">
                <option value="">-- 請選擇 --</option>
                <option value="occupational_safety">職業安全</option>
                <option value="environmental_protection">環境保護</option>
                <option value="health_welfare">衛生福利</option>
              </select>
            </div>
          </div>

        <!-- 部會選擇 (多選下拉選單) -->
        <div class="search-control">
          <label for="pubGovFilter">發布機關：</label>
          <div class="multi-select-container">
            <div class="multi-select-header" (click)="toggleDropdown('pubGov')">
              <span *ngIf="!selectedPubGovs.length">全部部會</span>
              <span *ngIf="selectedPubGovs.length">已選 {{ selectedPubGovs.length }} 個部會</span>
              <i class="material-icons">{{ isPubGovDropdownOpen ? 'arrow_drop_up' : 'arrow_drop_down' }}</i>
            </div>
            <div class="multi-select-dropdown" *ngIf="isPubGovDropdownOpen">
              <div class="dropdown-search">
                <input type="text" placeholder="搜尋部會..." [(ngModel)]="pubGovSearchTerm" (input)="filterPubGovs()">
              </div>
              <div class="select-all-option">
                <label>
                  <input type="checkbox" [checked]="isAllPubGovsSelected()" (change)="toggleAllPubGovs()">
                  全選/取消全選
                </label>
              </div>
              <div class="options-container">
                <div *ngFor="let gov of filteredPubGovs" class="checkbox-option">
                  <label>
                    <input type="checkbox" [checked]="isPubGovSelected(gov)" (change)="togglePubGov(gov)">
                    {{ gov }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 法規位階選擇 (多選下拉選單) -->
        <div class="search-control">
          <label for="docStyleFilter">法規位階：</label>
          <div class="multi-select-container">
            <div class="multi-select-header" (click)="toggleDropdown('docStyle')">
              <span *ngIf="!selectedDocStyles.length">全部位階</span>
              <span *ngIf="selectedDocStyles.length">已選 {{ selectedDocStyles.length }} 個位階</span>
              <i class="material-icons">{{ isDocStyleDropdownOpen ? 'arrow_drop_up' : 'arrow_drop_down' }}</i>
            </div>
            <div class="multi-select-dropdown" *ngIf="isDocStyleDropdownOpen">
              <div class="dropdown-search">
                <input type="text" placeholder="搜尋位階..." [(ngModel)]="docStyleSearchTerm" (input)="filterDocStyles()">
              </div>
              <div class="select-all-option">
                <label>
                  <input type="checkbox" [checked]="isAllDocStylesSelected()" (change)="toggleAllDocStyles()">
                  全選/取消全選
                </label>
              </div>
              <div class="options-container">
                <div *ngFor="let style of filteredDocStyles" class="checkbox-option">
                  <label>
                    <input type="checkbox" [checked]="isDocStyleSelected(style)" (change)="toggleDocStyle(style)">
                    {{ style }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 關鍵字搜尋 -->
        <div class="search-control">
          <label for="keywordSearch">法規名稱關鍵字：</label>
          <div class="search-input-container">
            <input
              type="text"
              id="keywordSearch"
              placeholder="輸入關鍵字搜尋..."
              [(ngModel)]="keywordSearchTerm"
             >
          </div>
        </div>


      </div>

      <!-- 搜尋操作按鈕區域，獨立放置 -->
      <div class="search-actions">
        <div class="action-buttons">
          <button class="action-btn search-apply" (click)="applySearch()">
            <i class="material-icons">search</i> 搜尋
          </button>
          <button class="action-btn search-clear" (click)="clearSearch()">
            <i class="material-icons">clear</i> 清除條件
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- 新增內容容器，包含側邊欄和詳細面板 -->
  <div class="content-container">
    <div class="sidebar">
     <div class="sidebar-header">
      <span *ngIf="latestUpdateDate" class="update-date">更新日期：{{ latestUpdateDate }}</span>
    </div>

      <div *ngIf="isLoadingTree" class="loading-spinner">
        <mat-spinner diameter="40"></mat-spinner>
        <p>載入中...</p>
      </div>

      <div *ngIf="errorMessage" class="error-message">
        <p>{{ errorMessage }}</p>
      </div>

      <div class="tree-container">
        <!-- 年份列表 -->
        <div *ngFor="let yearNode of years" class="year-node">
          <div class="year-header" (click)="toggleYear(yearNode)">
            <span class="toggle-icon">{{ yearNode.expanded ? '-' : '+' }}</span>
            <span class="node-name">{{ yearNode.year }}</span>
            <span class="node-count">{{ yearNode.totalCount }}</span>
          </div>

          <!-- 月份列表 (可展開/收合) -->
          <div *ngIf="yearNode.expanded" class="month-list">
            <div *ngFor="let monthNode of yearNode.months"
                 class="month-node"
                 [class.selected]="selectedMonth === monthNode.month"
                 (click)="selectMonth(monthNode.month)">
              <span class="node-name">{{ monthNode.name }}</span>
              <span class="node-count">{{ monthNode.count }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="details-panel">
      <div *ngIf="!selectedMonth" class="no-selection">
        <p>請選擇月份以查看法規更新詳情</p>
      </div>

      <div *ngIf="selectedMonth" class="month-details">
        <h2>{{ selectedMonth }} 法規更新</h2>

        <div *ngIf="isLoadingMonthDetails" class="loading-spinner">
          <mat-spinner diameter="40"></mat-spinner>
          <p>載入詳情中...</p>
        </div>

        <div *ngIf="!isLoadingMonthDetails && monthDetails.length === 0" class="no-details">
          <p>本月無法規更新</p>
        </div>

        <!-- 關鍵字標籤區域 -->
        <div *ngIf="!isLoadingMonthDetails && keywordCounts.size > 0" class="keyword-tags-container" [class.collapsed]="isKeywordCollapsed">
          <div class="keyword-tags-header">
            <h3>關鍵字篩選</h3>
            <div class="header-actions">
              <button *ngIf="selectedKeywords.size > 0" class="clear-filters-btn" (click)="clearKeywordFilters()">
                清除篩選
              </button>
              <button class="toggle-btn" (click)="toggleKeywordCollapse()">
                <i class="material-icons">{{ isKeywordCollapsed ? 'expand_more' : 'expand_less' }}</i>
              </button>
            </div>
          </div>

          <div class="keyword-content" [class.hidden]="isKeywordCollapsed">
            <div class="keyword-tags">
              <span
                *ngFor="let entry of keywordCounts | keyvalue"
                class="keyword-tag"
                [class.selected]="isKeywordSelected(entry.key)"
                (click)="toggleKeyword(entry.key)">
                {{entry.key}} ({{entry.value}})
              </span>
            </div>

            <div class="filter-info">
              顯示 {{ monthDetails.length }} / {{ originalMonthDetails.length }} 筆資料
            </div>
          </div>
        </div>

        <div class="details-list" *ngIf="!isLoadingMonthDetails && monthDetails.length > 0">
          <div *ngFor="let detail of monthDetails"
               class="detail-card"
               [class.read]="detail.read">
            <div class="detail-header">
              <!-- 新增操作按鈕區塊 -->
              <div class="action-buttons">
                <button class="action-btn view-details" (click)="viewDetailedInfo(detail)">
                  <i class="material-icons">visibility</i> 檢視詳細資料
                </button>
                <button class="action-btn add-to-list" (click)="openAddToRegulationListDialog(detail)">
                  <i class="material-icons">add_circle</i> 加入法規清單
                  <span *ngIf="detail.topicTypeList && detail.topicTypeList.length > 0" class="topic-count">
                    {{ getDistinctTopicsCount(detail.topicTypeList) }}
                  </span>
                </button>
                <!-- 標記為已讀按鈕，改為使用 detail.read 欄位判斷狀態 -->
                <button class="action-btn mark-as-read"
                        [class.marked-as-read]="detail.read"
                        (click)="markAsRead(detail)">
                  <i class="material-icons" *ngIf="!detail.read">check_box_outline_blank</i>
                  <i class="material-icons" *ngIf="detail.read">check_box</i>
                  {{ detail.read ? '已讀' : '標記為已讀' }}
                </button>
              </div>
              <h3 class="detail-title">{{ detail.lawname }}</h3>
              <div class="detail-meta">
                <div class="meta-row">
                  <span class="meta-label">發布日期:</span>
                  <span class="meta-value">{{ detail.Date_Published }}</span>
                </div>
                <div class="meta-row">
                  <span class="meta-label">文件標題:</span>
                  <span class="meta-value">{{ detail.Title }}</span>
                </div>
                <div class="meta-row">
                  <span class="meta-label">法規類別:</span>
                  <span class="meta-value">{{ detail.Doc_Style_LName }}</span>
                </div>
                <div class="meta-row">
                  <span class="meta-label">發布機關:</span>
                  <span class="meta-value">{{ detail.PubGov }}</span>
                </div>
                <div class="meta-row">
                  <span class="meta-label">公報編號:</span>
                  <span class="meta-value">{{ detail.GazetteId }}</span>
                </div>
                <div class="meta-row">
                  <span class="meta-label">關鍵字:</span>
                  <span class="meta-value">{{ detail.Keyword }}</span>
                </div>
              </div>
            </div>
            <div class="detail-content">
              <p class="regulation-explanation">{{ detail.Explain }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 全螢幕彈出視窗 -->
  <div class="popup fullscreen" *ngIf="isPopupVisible">
    <div class="popup-content">
      <!-- 關閉按鈕 -->
      <button class="close-btn" (click)="closePopup()">關閉</button>

      <!-- 法規詳細資訊 -->
      <div class="law-info" *ngIf="selectedDetailInfo">
        <h2>{{ selectedDetailInfo.lawname }}</h2>

        <!-- <div class="meta-grid">
          <div class="meta-item">
            <span class="meta-label">發布日期:</span>
            <span class="meta-value">{{ selectedDetailInfo.Date_Published }}</span>
          </div>
          <div class="meta-item">
            <span class="meta-label">法規類別:</span>
            <span class="meta-value">{{ selectedDetailInfo.Doc_Style_LName }} ({{ selectedDetailInfo.Doc_Style_SName }})</span>
          </div>
          <div class="meta-item">
            <span class="meta-label">發布機關:</span>
            <span class="meta-value">{{ selectedDetailInfo.PubGov }}{{ selectedDetailInfo.PubGovName ? ' - ' + selectedDetailInfo.PubGovName : '' }}</span>
          </div>
          <div class="meta-item">
            <span class="meta-label">公報編號:</span>
            <span class="meta-value">{{ selectedDetailInfo.GazetteId }}</span>
          </div>
          <div class="meta-item">
            <span class="meta-label">關鍵字:</span>
            <span class="meta-value">{{ selectedDetailInfo.Keyword }}</span>
          </div>
        </div> -->

        <div class="title-section">
          <div class="section-title">標題</div>
          <div class="section-content">{{ selectedDetailInfo.Title }}</div>
        </div>

        <div class="explain-section">
          <div class="section-title">說明</div>
          <div class="section-content">{{ selectedDetailInfo.Explain }}</div>
        </div>

        <!-- 法規內容區域 -->
        <div class="html-content-section" *ngIf="selectedDetailInfo.HTMLContent">
          <div class="section-title">完整內容</div>
          <div class="html-content" [innerHTML]="transformHtmlContent(selectedDetailInfo)"></div>
        </div>

        <!-- 操作按鈕 -->
        <!-- <div class="action-buttons popup-actions">
          <button class="action-btn add-to-list" (click)="addToRegulationList()">
            <i class="material-icons">add_circle</i> 加入法規清單
          </button>
          <button class="action-btn hide-item" (click)="hideRegulation(selectedDetailInfo); closePopup()">
            <i class="material-icons">visibility_off</i> 不再顯示
          </button>
        </div> -->
        <!-- <div class="action-buttons popup-actions">
          <button class="action-btn add-to-list" (click)="openAddToRegulationListDialog(selectedDetailInfo)">
            <i class="material-icons">add_circle</i> 加入法規清單
          </button>
          <button class="action-btn mark-as-read"
                  [class.marked-as-read]="selectedDetailInfo.read"
                  (click)="markAsRead(selectedDetailInfo); $event.stopPropagation()">
            <i class="material-icons" *ngIf="!selectedDetailInfo?.read">check_box_outline_blank</i>
            <i class="material-icons" *ngIf="selectedDetailInfo?.read">check_box</i>
            {{ selectedDetailInfo.read ? '已讀' : '標記為已讀' }}
          </button>
        </div> -->
      </div>
    </div>
  </div>

  <!-- 加入按鈕區域 - 加入法規清單按鈕 -->
  <!-- <div class="action-buttons">
    <button class="action-btn add-btn" (click)="openAddToRegulationListDialog()">
      <i class="fa-solid fa-plus"></i> 加入法規清單
    </button>
  </div> -->

  <!-- 添加法規對話框 -->
  <div class="dialog-overlay" *ngIf="showAddToRegulationDialog">
    <div class="dialog-container">
      <div class="dialog-header">
        <h3>加入法規清單</h3>
        <button class="close-btn" (click)="closeAddToRegulationListDialog()">×</button>
      </div>

      <div class="dialog-body">
        <!-- 第一步：選擇主題 -->
        <div *ngIf="addDialogStep === 1">
          <h4>請選擇要加入的主題</h4>
          <div class="topic-list">
            <div *ngFor="let topic of companyTopics"
                 class="topic-item"
                 [class.active]="selectedAddTopic === topic"
                 [class.already-added]="isTopicInDetailList(topic)"
                 [class.disabled]="isTopicInDetailList(topic)"
                 (click)="isTopicInDetailList(topic) ? null : selectAddTopic(topic)">
              <!-- 添加打勾符號 -->
              <span *ngIf="isTopicInDetailList(topic)" class="topic-check-mark">
                <i class="fa-solid fa-check"></i>
              </span>
              {{ topic }}
              <!-- 已添加標記 -->
              <span *ngIf="isTopicInDetailList(topic)" class="already-added-label">
                (已添加)
              </span>
            </div>
            <div *ngIf="isLoadingTopics" class="loading-indicator">
              <i class="fa-solid fa-spinner fa-spin"></i> 載入中...
            </div>
            <div *ngIf="!isLoadingTopics && companyTopics.length === 0" class="no-data">
              此公司尚未建立主題
            </div>
          </div>
        </div>

        <!-- 第二步：選擇分類 -->
        <div *ngIf="addDialogStep === 2">
          <h4>請選擇要加入的法規分類</h4>
          <!-- 新增：自行輸入法規分類選項 -->
          <div class="custom-type-input">
            <input type="text"
                   placeholder="輸入自定義法規分類"
                   [(ngModel)]="customTypeInput"
                   class="form-control">
            <button class="btn add-custom-btn"
                    style="height: 100%;"
                    [disabled]="!customTypeInput.trim()"
                    (click)="selectAddType(customTypeInput)">
              <i class="fa fa-plus"></i> 使用此分類
            </button>
          </div>
          <div class="or-divider">
            <span>或從現有分類中選擇</span>
          </div>
          <div class="type-list">
            <div *ngFor="let type of topicTypes"
                class="type-item"
                [class.active]="selectedAddType === type.type"
                (click)="selectAddType(type.type)">
              {{ type.type }}
            </div>
            <div *ngIf="isLoadingTypes" class="loading-indicator">
              <i class="fa-solid fa-spinner fa-spin"></i> 載入中...
            </div>
            <div *ngIf="!isLoadingTypes && topicTypes.length === 0" class="no-data">
              此主題尚未建立法規分類
            </div>
          </div>
          <div class="back-button">
            <button class="btn secondary-btn" (click)="backToTopicSelection()">
              <i class="fa-solid fa-arrow_left"></i> 返回主題選擇
            </button>
          </div>
        </div>
      </div>

      <div class="dialog-footer">
        <button class="btn cancel-btn" (click)="closeAddToRegulationListDialog()">取消</button>
        <button class="btn primary-btn"
                [disabled]="(addDialogStep === 1 && !selectedAddTopic) ||
                           (addDialogStep === 2 && !selectedAddType)"
                (click)="proceedAddToRegulationList()">
          {{ addDialogStep === 1 ? '下一步' : '加入法規清單' }}
        </button>
      </div>
    </div>
  </div>
</div>
